
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labs/[author]/products",
      function () {
        return require("private-next-pages/labs/[author]/products/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labs/[author]/products"])
      });
    }
  